"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _lodash = _interopRequireDefault(require("lodash.throttle"));
var _storage = _interopRequireWildcard(require("./storage"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var THROTTLE_TIME = 500; // 1/2 second;

function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var storage = new _storage["default"](_storage.STORAGE_TYPE_LOCAL);
  var intervalHandle = null;
  function createCheck(name, timeoutInMinutes) {
    var check = {
      name: name,
      storageKey: "bridge.".concat(name, ".name"),
      timeoutInMinutes: timeoutInMinutes,
      timeoutInMilliseconds: timeoutInMinutes * 60000,
      isStoped: false
    };
    check.stop = function () {
      check.isStoped = true;
    };
    check.resume = function () {
      check.isStoped = false;
    };
    check.clear = function () {
      storage.removeItem(check.storageKey);
    };
    check.record = function () {
      var timeoutAt = new Date(new Date().getTime() + check.timeoutInMilliseconds);
      // set the new time out at
      storage.setItem(check.storageKey, timeoutAt.toISOString());
    };
    check.run = function () {
      if (check.isStoped) {
        return false;
      }
      // get the timeout at time
      var timeoutAt = storage.getItem(check.storageKey);
      // check if now is beyond the timeout at
      if (timeoutAt && new Date() >= new Date(timeoutAt)) {
        check.stop();
        return true;
      }
      return false;
    };
    return check;
  }
  var promptCheck = createCheck('prompt', options.activityPromptInMinutes || 2.5);
  var signOutCheck = createCheck('signOut', options.activityTimeoutInMinutes || 5);
  function recordActivity() {
    if (!promptCheck.isStoped && !signOutCheck.isStoped) {
      promptCheck.record();
      signOutCheck.record();
    }
  }
  var throttledRecordActivity = (0, _lodash["default"])(recordActivity, THROTTLE_TIME);
  function startChecking(promptCallback, signOutCallback) {
    // stop activity tracking in case it is already happening
    stopChecking();
    // record activity to set an initial value;
    recordActivity();

    // add an interval to check that the activity timeout has not been exceeded
    intervalHandle = window.setInterval(function () {
      if (promptCheck.run()) {
        promptCheck.stop();
        if (typeof promptCallback === 'function') {
          promptCallback({
            timeoutAt: new Date(storage.getItem(signOutCheck.storageKey)),
            "continue": function _continue() {
              recordActivity();
              promptCheck.resume();
            },
            signOut: function signOut() {
              if (typeof signOutCallback === 'function') {
                signOutCallback(true);
              }
            }
          });
        }
      }
      if (signOutCheck.run()) {
        signOutCheck.stop();
        if (typeof signOutCallback === 'function') {
          signOutCallback();
        }
      }
    }, THROTTLE_TIME);
    // add mouse move event handler to track activity
    window.addEventListener('mousemove', throttledRecordActivity);
  }
  function stopChecking() {
    // clear storage value
    promptCheck.clear();
    signOutCheck.clear();
    // clear timeout
    if (intervalHandle) {
      window.clearInterval(intervalHandle);
      intervalHandle = null;
      // remove mouse move event handler
      window.removeEventListener('mousemove', throttledRecordActivity);
    }
  }
  return {
    checkForTimeout: signOutCheck.run,
    startChecking: startChecking,
    stopChecking: stopChecking,
    recordActivity: recordActivity
  };
}
//# sourceMappingURL=activity-timeout.js.map